<script setup>
import { useBookingStore } from "../../../Registration/stores/bookingStore"
import { computed } from "vue"

const props = defineProps({
  path: { type: String, required: true },
  backend: { type: Object, default: null }
})

// Use backend if provided, otherwise fallback to store
const getErrors = () => {
  if (props.backend) {
    return props.backend.getErrors()
  }
  const booking = useBookingStore()
  return booking.errors
}

const hasError = computed(() => {
  const errors = getErrors()
  return errors.hasOwnProperty(props.path)
})

const errorMessage = computed(() => {
  const errors = getErrors()
  return errors[props.path]?.[0]
})

const errorId = computed(() => `error-${props.path}`)

</script>

<template>
    <div  v-if="hasError"
          :id="errorId"
          class="field-error-message flex items-center w-full text-[10px] mt-0.5 text-red-500"
          role="alert"
          aria-live="assertive"
          v-html="errorMessage" />
</template>

<style scoped>

</style>
